import { FormikProps } from 'formik';
import { Dispatch } from 'redux';
import Cleave from 'cleave.js/react';
import { Button, Col, Input, Label, Row } from 'reactstrap';
import { useSelector } from 'react-redux';
import { RootState } from 'slices';
import { useTranslation } from 'react-i18next';

import { useEffect } from 'react';
import FluidContainerClean from 'Components/pos2u/Wrappers/FluidContainer';
import { EditInventoryForm } from 'types/product/productInventoryTypes';
import {
  setCountInventorySubmit,
  setInventoryFormErrorCount,
  setShowAllValidateInventoryErrors,
} from 'slices/productInventory/reducer';

interface CustomInputElement extends HTMLInputElement {
  rawValue: string;
}
const InventoryForm = ({
  dispatch,
  formik,
}: {
  dispatch: Dispatch;
  formik: FormikProps<EditInventoryForm>;
}) => {
  const { t } = useTranslation();
  // const infoState = useSelector((state: RootState) => state.Info);
  // const { branchCodes } = infoState;
  const productInventoryState = useSelector(
    (state: RootState) => state.ProductInventory
  );
  const { InventoryModal } = productInventoryState;

  useEffect(() => {
    dispatch(setInventoryFormErrorCount(Object.keys(formik.errors).length));
  }, [formik.errors, dispatch]);
  // console.log(formik.values);
  // console.log(formik.errors);
  // console.log(formik.errors.cost_price);
  return (
    <>
      <div className={`mb-3 row`}>
        <Label htmlFor="#" className="col-sm-4 col-form-label">
          {t('Barcode ID')}
        </Label>
        <Col sm={8} className="d-flex align-items-center">
          <FluidContainerClean>
            <Input
              type="text"
              name={`barcode`}
              value={formik.values.barcode || ''}
              onChange={formik.handleChange}
              className="me-2"
              disabled
            />
          </FluidContainerClean>
        </Col>
      </div>
      <div className={`mb-3 row`}>
        <Label htmlFor="#" className="col-sm-4 col-form-label">
          {t('Item Name')}
        </Label>
        <Col sm={8} className="d-flex align-items-center">
          <FluidContainerClean>
            <Input
              type="text"
              name={`name`}
              value={formik.values.name || ''}
              onChange={formik.handleChange}
              className="me-2"
              disabled
            />
          </FluidContainerClean>
        </Col>
      </div>
      <div className={`mb-3 row`}>
        <Label htmlFor="#" className="col-sm-4 col-form-label">
          {t('Category')}
        </Label>
        <Col sm={8} className="d-flex align-items-center">
          <FluidContainerClean>
            <Input
              type="text"
              name={`categoryName`}
              value={formik.values.categoryName || ''}
              onChange={formik.handleChange}
              className="me-2"
              disabled
            />
          </FluidContainerClean>
        </Col>
      </div>
      <div className={`mb-3 row`}>
        <Label htmlFor="#" className="col-sm-4 col-form-label">
          {t('Current Quantity')}
        </Label>
        <Col sm={8} className="d-flex align-items-center">
          <FluidContainerClean>
            <Input
              type="text"
              name={`currentQuantity`}
              value={formik.values.currentQuantity || ''}
              onChange={formik.handleChange}
              className="me-2"
              disabled
            />
          </FluidContainerClean>
        </Col>
      </div>
      <div className={`mb-3 row`}>
        <Label htmlFor="#" className="col-sm-4 col-form-label">
          {t('Inventory to add/subtract')}{' '}
          <span style={{ color: 'red' }}>*</span>
        </Label>
        <Col sm={8} className="d-flex align-items-center">
          <FluidContainerClean>
            <Cleave
              className={`form-control`}
              name={`adjustQuantity`}
              value={formik.values.adjustQuantity || ''}
              options={{
                numeral: true,
                numeralDecimalScale: 3,
                numeralThousandsGroupStyle: 'thousand',
              }}
              // onChange={formik.handleChange}
              onChange={(e: React.ChangeEvent<CustomInputElement>) => {
                formik
                  .setFieldValue('adjustQuantity', e.target.rawValue)
                  .then(() => {
                    formik.setFieldTouched('adjustQuantity', true);
                  });
              }}
              onBlur={formik.handleBlur}
            />
            {(formik.touched.adjustQuantity && formik.errors.adjustQuantity) ||
            (formik.isValid === false &&
              formik.errors.adjustQuantity &&
              InventoryModal.showAllValidateErrors === true) ? (
              <div className="text-danger">{formik.errors.adjustQuantity}</div>
            ) : null}
          </FluidContainerClean>
        </Col>
      </div>
      <div className={`mb-3 row`}>
        <Label htmlFor="#" className="col-sm-4 col-form-label">
          {t('INV_Comments')} <span style={{ color: 'red' }}>*</span>
        </Label>
        <Col sm={8} className="d-flex align-items-center">
          <FluidContainerClean>
            <textarea
              className="form-control"
              id="transComment"
              name="transComment"
              value={formik.values.transComment}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              rows={3}
            ></textarea>
            {(formik.touched.transComment && formik.errors.transComment) ||
            (formik.isValid === false &&
              formik.errors.transComment &&
              InventoryModal.showAllValidateErrors === true) ? (
              <div className="text-danger">{formik.errors.transComment}</div>
            ) : null}
          </FluidContainerClean>
        </Col>
      </div>

      <Row>
        <Col xs={12} sm={12} className="text-center">
          <div className="mb-3">
            <Row>
              <Col xs={0} sm={4}></Col>

              <Col xs={5} sm={3}>
                <Button
                  block
                  color="success"
                  type="submit"
                  id="edit-price-save"
                  disabled={
                    InventoryModal.FormErrorCount !== 0 || formik.isSubmitting
                  }
                  // disabled={formik.isSubmitting}
                  onClick={async () => {
                    await formik.setTouched(
                      Object.keys(formik.initialValues).reduce(
                        (acc, key) => ({ ...acc, [key]: true }),
                        {}
                      )
                    );
                    dispatch(setShowAllValidateInventoryErrors(true));
                    dispatch(setCountInventorySubmit());
                  }}
                >
                  {t('Btn_Save')}
                </Button>
              </Col>
              {/* <Col xs={1} sm={3}></Col> */}
            </Row>
          </div>
        </Col>
      </Row>
    </>
  );
};

export default InventoryForm;
